// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"40fc8518","885":"504ba304"}[chunkId] + ".chunk.js";
};